import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import {
  PaidInManagerApproval,
  PaidInProhibhitBeyondBoundryamount,
} from 'src/common/helpers/error-code';
import { getTouchPointNotifications } from 'src/touchpoint-notifications/get-touchpoint-notifications';
import { checkAndGetArray } from '../../common/helpers/array-helper';
import { IReceipt } from '../../common/interfaces/dtos/IReceipt';
import { CashOfficeMenuState } from '../../common/interfaces/states/CashOfficeMenuState';
import { store } from '../../common/redux/configure-store';
import { printReceipts } from '../../devices/printer-operations';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { closeDrawer } from '../components/cash-drawer-actions';
import { AmountAndTender, PaidActionRequest } from '../interfaces/PaidActionRequest';
import { postPaidIn } from './services/post-paid-in';

export const processPaidIn = async (
  tenderMenuGroups: Partial<CashOfficeMenuState>,
  accountId: string,
  taxable: boolean = false,
  taxAmount?: number,
  taxType?: string,
): Promise<void> => {
  const paidInRequest: PaidActionRequest = {
    source: accountId,
    destination: store.getState().touchPoint.touchPointConfiguration.accountExternalId ?? '',
    taxable,
    amountAndTender: createAmountAndTenderList(tenderMenuGroups),
    taxAmount: taxAmount,
    taxType: taxType,
  };

  await postPaidIn(paidInRequest)
    .then(
      async (receipts: IReceipt[]): Promise<void> => {
        if (receipts && receipts.length > 0) {
          await printReceipts(checkAndGetArray(receipts)).catch(popupMessage);
        }
        popEmeraldModal();
        closeDrawer();
        await getTouchPointNotifications();
      },
    )
    .catch(err => {
      if (err.code === PaidInProhibhitBeyondBoundryamount) {
        err.code = 'Prohibit';
        popupMessage(err);
      } else if (err.code !== PaidInManagerApproval) {
        popEmeraldModal();
        popupMessage(err);
      }
    });
};

const createAmountAndTenderList = (
  tenderMenuGroups: Partial<CashOfficeMenuState>,
): AmountAndTender[] => {
  const tenderPickupRequestList: AmountAndTender[] = [];
  if (tenderMenuGroups.sellableTenders && tenderMenuGroups.sellableTenders?.tenderGroups) {
    return tenderMenuGroups.sellableTenders.tenderGroups.flatMap(tenderGroup => {
      const tenderList = tenderGroup.tenderCountList || [];
      return tenderList.map(tenderCountEntry => {
        const amountAndTender: AmountAndTender = {
          amount: tenderCountEntry.denomination
            ? tenderCountEntry.denomination.amount
            : tenderCountEntry.amount,
          tender: `Tender:${tenderCountEntry.tenderId}`,
        };

        if (tenderCountEntry.denomination) {
          const denom = tenderCountEntry.denomination;
          amountAndTender.denomination = `${denom.type}:${denom.description}`;
          amountAndTender.count = denom.count;
        }

        return amountAndTender;
      });
    });
  }

  return tenderPickupRequestList;
};
